"use strict";
var base = require("./base");
const constants = require("../helpers/const");
const { initProductThumbnails } = require("./productThumbnails");
const { moveToActiveColor, initColorsCarousel } = require("./productColorCarouselHelpers");
const gtmHelpers = require("../helpers/gtmHelpers");
const { matchWidth } = require("../components/matchWidth");
const { initPhotoSwipe } = require("./photoSwipe");

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $("button.add-to-cart-global").attr("disabled", enableOrDisable);
}

/**
 * Animates scrolling to a specific element on the page
 * @param {jQuery} reviewsAccordionBtn - the jQuery object representing the reviews accordion button
 * @returns {void}
 */
function animatedScroll(reviewsAccordionBtn, offset) {
    setTimeout(() => {
        $("html, body").animate(
            {
                scrollTop: reviewsAccordionBtn.offset().top - offset,
            },
            500
        );
    }, 500);
}

/**
 * Displays TrustPilot reviews for a product
 * @param {Object} data - the data containing product reviews and links
 * @param {Element} reviewsContainer - the container element for displaying reviews
 * @returns {void}
 */
const getTrustPilotReviews = (data, reviewsContainer) => {
    reviewsContainer.spinner().start();
    let links = "";
    let reviews = "";
    const serviceError = reviewsContainer.data("service-error");
    const reviewContainer = $("#reviewsCollapse");

    if (!data || !data.result || !data.result.productReviewsResult.productReviews) {
        reviewsContainer.html(`<p class="service-error">${serviceError}</p>`);
        reviewsContainer.spinner().stop();
        return;
    }
    data.result.productReviewsResult.productReviews.forEach(function (review) {
        let stars = "";
        let fullStarSvg = constants.Stars.fullStarSvg;
        let emptyStarSvg = constants.Stars.emptyStarSvg;
        const serviceErrorMessage = $(".service-error");

        if (serviceErrorMessage.length) {
            serviceErrorMessage.remove();
        }

        for (let i = 0; i < 5; i++) {
            if (review.stars > i) {
                stars += fullStarSvg;
            } else {
                stars += emptyStarSvg;
            }
        }
        reviews += `
            <div class="review">
                <div class="rating-name">${review.name} ${review.date}</div>
                <div class="rating-stars">${stars}</div>
                <div class="rating-content">${review.content}</div>
            </div>
        `;
    });

    if (data.result.attributeSummariesResult?.attributeSummaries && reviewContainer.find(".rating-display").length === 0) {
        $("body").trigger("product:displayTrustPilotAttributeSummaries", {data, container: reviewContainer});
    }

    data.result.productReviewsResult.links.forEach(function (link) {
        links += `<a class="${link.rel} pagination-btn" href="${link.sfccHref}">${link.title}</a>`;
    });

    reviewsContainer.append(reviews);
    reviewsContainer.append(links);
    reviewsContainer.spinner().stop();
};

/**
 * Handler responsible to scrolling the reivews section into view
 * @param {String} btnClassName - the classname of the button to trigger the scroll
 * @returns {void}
 */
const scrollToReviewsHandler = (btnClassName) => {
    const reviewsAccordionBtn = $(".ratings-reviews-accordion").find(".accordion-button");
    if (!reviewsAccordionBtn.length) {
        return;
    }
    $(btnClassName).on("click", function () {
        if (!reviewsAccordionBtn.hasClass("collapsed")) {
            animatedScroll(reviewsAccordionBtn, 0);
            return;
        }

        reviewsAccordionBtn.trigger("click");
        animatedScroll(reviewsAccordionBtn, 0);
    });
};

/**
 * Fetches Trustpilot attribute summaries and injects them into the Size & Fit content.
 * Guarded so it only fires once per page; safe to call from the click handler or on init
 * when the Size & Fit accordion renders pre-expanded (expandSizeAndFitOnPDP).
 * @param {jQuery} $accordionButton - the size-and-fit accordion button jQuery element
 * @returns {void}
 */
const loadSizeAndFitAttributes = ($accordionButton) => {
    if ($("#sizeandfitContent .rating-display").length !== 0) {
        return;
    }
    // The labels element is rendered by trustpilotWidget.isml inside #sizeandfit only
    // when trustpilotSizeEnabled, trustpilotSizeThreshold, and product.trustpilotReviewCount
    // are all truthy. Without it there's nothing to populate, so skip the API call
    // entirely — also prevents reading data-review-labels off an undefined element.
    const $reviewsRangeDisplays = $("#sizeandfit").find(".reviews-range-displays");
    if (!$reviewsRangeDisplays.length || !$reviewsRangeDisplays.data("review-labels")) {
        return;
    }
    const callUrl = $accordionButton.data("attributes-url");
    if (!callUrl) {
        return;
    }
    $.ajax({
        url: callUrl,
        method: "GET",
        success: function (data) {
            if (!data?.result?.attributeSummariesResult?.attributeSummaries) {
                return;
            }
            if ($("#sizeandfit").find(".rating-display").length !== 0 || $("#reviewsCollapse").length === 0) {
                return;
            }
            const sizeandfitContentElement = $("#sizeandfitContent");
            const reviewsLabels = $reviewsRangeDisplays.data("review-labels");

            const labelsObject = reviewsLabels.split(",").reduce((acc, pair) => {
                const [key, value] = pair.split(":").map(item => item.trim());
                acc[key] = value;
                return acc;
            }, {});

            const readReviewsButton = `<button class="read-reviews-button">${labelsObject.readReviews}</button>`;
            sizeandfitContentElement.prepend(readReviewsButton);
            scrollToReviewsHandler(".read-reviews-button");
            $("body").trigger("product:displayTrustPilotAttributeSummaries", {data, container: sizeandfitContentElement});
        }
    });
};

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,
    },

    availability: base.availability,

    addToCart: base.addToCart,

    /**
     * Initializes the colors carousel for the product detail page
     */
    initColorsCarousel: initColorsCarousel(),
    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid=\"" + data.id + "\"]");

            $productContainer.find(".description-and-detail .product-attributes").empty().html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description").removeClass("hidden-xl-down");
                $productContainer
                    .find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description").addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details").removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content").empty().html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details").addClass("hidden-xl-down");
            }
        });
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            if ($(".product-detail>.bundle-items").length || $(".product-set-detail").eq(0)) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not(\".bundle-item\")").data("pid", response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function () {
            // update local add to cart (for sets)

            var enable = $(".product-availability")
                .toArray()
                .every(function (item) {
                    return $(item).data("available") && $(item).data("ready-to-order");
                });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer).empty().html(response.message);

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability")
                    .toArray()
                    .every(function (item) {
                        return $(item).data("available");
                    });

                var allReady = $(".product-availability")
                    .toArray()
                    .every(function (item) {
                        return $(item).data("ready-to-order");
                    });

                $(".global-availability").data("ready-to-order", allReady).data("available", allAvailable);

                $(".global-availability .availability-msg")
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    copyProductLink: function () {
        $("body").on("click", "#fa-link", function () {
            event.preventDefault();
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($("#shareUrl").val()).select();
            document.execCommand("copy");
            $temp.remove();
            $(".copy-link-message").attr("role", "alert");
            $(".copy-link-message").removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        });
    },
    /**
     * Controls the visibility of the "Add to Cart" sticky button based on intersection with other elements
     */
    addToCartStickyButtonVisibility: function () {
        const elementToHide = document.querySelector(".add-to-cart-sticky");
        const buttonWrapper = document.querySelector(".prices-add-to-cart-actions.sticky");
        const watchedElement = document.querySelector(".static-atb");
        const anotherWatchedElement = document.querySelector(".footer-sub");
        const navBar = document.querySelector(".main-menu");

        if (!elementToHide || !buttonWrapper || !watchedElement || !anotherWatchedElement || !navBar) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            const isNotifyMeVariantSelected = $(".custom-product-size-button.selected").hasClass("notify-me-available");
            entries.forEach((entry) => {
                if (entry.isIntersecting || isNotifyMeVariantSelected) {
                    elementToHide.classList.add("fade-out-atb");
                    elementToHide.classList.remove("fade-in-atb");
                    buttonWrapper.classList.add("disable-events");
                } else {
                    elementToHide.classList.add("fade-in-atb");
                    elementToHide.classList.remove("fade-out-atb");
                    buttonWrapper.classList.remove("disable-events");
                }
            });
        });

        observer.observe(watchedElement);
        observer.observe(anotherWatchedElement);
        observer.observe(navBar);
    },
    /**
     * Adds sticky behavior to the add to cart button
     */
    stickyAddToCart: function () {
        const $elementToHide = $(".add-to-cart-sticky");
        const $staticAtb = $(".static-atb");
        $elementToHide.on("click", function () {
            $staticAtb.trigger("click");
        });
    },
    /**
     * Adjusts the width of elements with the class 'custom-product-size-button' to match the width of the widest element.
     * Utilizes the matchWidth function to ensure uniform width across all matched elements.
     */
    callMatchWidth: function () {
        matchWidth($(".custom-product-size-button"));
    },
    /**
     * Populates the reviews accordion and triggers an event on button click
     */
    populateReviewsAccordion: function () {
        const reviewsAccordionBtn = $(".ratings-reviews-accordion").find(".accordion-button");
        if (reviewsAccordionBtn.length === 0) {
            return;
        }

        reviewsAccordionBtn.on("click", function () {
            const reviews = $(".review").length;

            if (reviews !== 0) {
                return;
            }
            // eslint-disable-next-line
            $("body").trigger("product:updateReviews");
        });
    },
    /**
     * Shows the reviews section and scrolls to it
     * @returns {void}
     */
    scrollToReviews: function () {
        // Product tiles reuse .ratings-btn on a static element, so only the button variant is bound
        scrollToReviewsHandler("button.ratings-btn");
    },

    /**
    * Attaches a click event listener to elements with the class 'size-fit-button'
    * that triggers an animated scroll to the element with the class 'size-and-fit-accordion'.
    */
    scrollToSizeAndFit: function () {
        $(".size-fit-button").on("click", function () {
            const sizeAccordion = $(".size-and-fit-accordion");

            if (sizeAccordion.hasClass("collapsed")) {
                animatedScroll(sizeAccordion, 0);
            }
        });
    },

    /**
     * Attaches a click event listener to the size-and-fit accordion that triggers an
     * api call to get data for the product attribute range display. When the accordion
     * renders pre-expanded (expandSizeAndFitOnPDP site preference) the click never
     * fires on initial load, so the fetch is also invoked directly on init in that case.
     */
    openSizeAndFit: function () {
        const $accordion = $(".size-and-fit-accordion");

        $accordion.on("click", function () {
            loadSizeAndFitAttributes($(this));
        });

        // expandSizeAndFitOnPDP renders the panel pre-expanded (no .collapsed class on
        // the button, .show on #sizeandfit) — kick the fetch ourselves so the Trustpilot
        // attribute summaries appear without the user toggling the accordion.
        if ($accordion.length && !$accordion.hasClass("collapsed")) {
            loadSizeAndFitAttributes($accordion);
        }
    },

    /**
     * Change the reviews page when a pagination button is clicked
     * @returns {void}
     */
    changeReviewsPage: function () {
        $(document).on("click", ".pagination-btn", function (e) {
            e.preventDefault();
            const linkUrl = $(this).attr("href");
            const reviewsContainer = $(".ratings-reviews");

            $.ajax({
                url: linkUrl,
                method: "GET",
                success: function (data) {
                    $(".ratings-reviews").html("");
                    getTrustPilotReviews(data, reviewsContainer);
                    animatedScroll($(".ratings-reviews-accordion").find(".accordion-button"), 150);
                },
                error: function () {
                    reviewsContainer.html("");
                    reviewsContainer.spinner().stop();
                },
            });
        });
    },
    /**
     * Shows Trustpilot reviews for a product
     * @returns {void}
     */
    showTrustpilotReviews: function () {
        $("body").on("product:updateReviews", function () {
            const reviewsContainer = $(".ratings-reviews");
            const callUrl = $(".ratings-reviews-accordion").data("review-url");

            $.ajax({
                url: callUrl,
                method: "GET",
                success: function (data) {
                    getTrustPilotReviews(data, reviewsContainer);
                },
                error: function () {
                    reviewsContainer.html("");
                    reviewsContainer.spinner().stop();
                },
            });
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal,
    /**
     * Initializes the product thumbnails
     */
    initializeProductThumbnails: initProductThumbnails,
    /**
     * Moves the color carousel to the active color
     */
    setupColorCarousel: moveToActiveColor(),
    pageViewEvent: gtmHelpers.pageViewEvent("PDP"),
    itemViewEvent: gtmHelpers.viewItemEvent(),
    /**
     * Removes the variation size param from pdp url
     */
    updatePDPUrl: function () {
        const url = window.location.href;
        let size = null;
        const params = url.split("_size=");

        if (params && params.length > 1) {
            size = params[params.length - 1];
        }

        if (size) {
            const $sizeButton = $(`.custom-product-size-button[data-attr-value='${size}']`);
            if ($sizeButton.length > 0 && !$sizeButton.attr("disabled")) {
                $sizeButton.trigger("click");
            }
        }

        let newUrl = url.replace(/&?product_\d+_size=\d+/g, "");

        if (newUrl.endsWith("?") || newUrl.endsWith("&")) {
            newUrl = newUrl.slice(0, -1);
        }
        window.history.replaceState({}, document.title, newUrl);
    },
    /**
     * Updates the Delivery & Returns section on pdp when selecting a country
     * @returns {void}
     */
    selectShippingToCountry: function () {
        $(".shipToCountry").on("change", function () {
            const $this = $(this);
            const url = $this.data("url");

            if (!url) return;

            const countryCode = $this.val();

            const urlWithParams = new URL(url);
            urlWithParams.searchParams.append("countryCode", countryCode);

            const $shipToCountryDataWrapper = $(".shipToCountry-data-wrapper");
            $shipToCountryDataWrapper.spinner().start();

            $.ajax({
                url: urlWithParams.toString(),
                method: "GET",
                success: function (data) {
                    if (data.shippingDataTemplate) {
                        $shipToCountryDataWrapper.html(data.shippingDataTemplate);
                    } else {
                        $shipToCountryDataWrapper.html("");
                    }
                    $shipToCountryDataWrapper.spinner().stop();
                },
                error: function () {
                    // TODO: to display an error message after BA provide it and leave previous delivery data rendered
                    $shipToCountryDataWrapper.spinner().stop();
                    $shipToCountryDataWrapper.html("");
                }
            });

        });
    },
    /**
    * Attaches a click event handler to elements with the class 'scroll-to-recommendations'.
    */
    scrollToRecommendations: function () {
        $(".scroll-to-recommendations").on("click", function () {
            const recommenders = $(".product-tile-carousel-wrapper");
            if (recommenders.length > 0) {
                animatedScroll(recommenders, 0);
            } else {
                animatedScroll($("footer"), 0);
            }
        });
    },
    /**
     * Initializes the PhotoSwipe image zoom functionality for product images
     */
    initPhotoSwipe: initPhotoSwipe
};
